import { useBreakpointValue } from '@melio/penny';

export const useIsMobile = () => useBreakpointValue({ xs: true, s: false }, { ssr: false } as never);
